// OPEN A BROKER LOGIN PAGE (owner 2026-10-22: "Generate Token on Settings does nothing on mobile"). Phone browsers
// (Safari, installed Home-Screen app) block window.open() called AFTER an await, so the login link fetched from the
// server never opened. Open the tab synchronously inside the tap, then send it to the URL; if even that is blocked,
// go there in this tab (the Fyers page shows the auth_code to paste back here).
export async function openLogin(getUrl) {
  let w = null;
  try { w = window.open('', '_blank'); } catch (e) { w = null; }
  let r;
  try { r = await getUrl(); } catch (e) { r = { status: 'error', message: 'Server not reachable' }; }
  if (r && r.status === 'success' && r.auth_url) {
    if (w && !w.closed) { try { w.location.href = r.auth_url; return r; } catch (e) { /* fall through */ } }
    window.location.href = r.auth_url;
    return r;
  }
  try { if (w) w.close(); } catch (e) { /* ignore */ }
  return r || { status: 'error', message: 'failed' };
}
